import { render, staticRenderFns } from "./publishRank.vue?vue&type=template&id=46a992da&scoped=true&"
import script from "./publishRank.vue?vue&type=script&lang=js&"
export * from "./publishRank.vue?vue&type=script&lang=js&"
import style0 from "./publishRank.vue?vue&type=style&index=0&id=46a992da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a992da",
  null
  
)

export default component.exports